import React from "react";
import {observer} from "mobx-react";

import "./legend.scss";

import {AppState} from "../../../stores/app-mobx";
import {UiState} from "../../../core/ui-state";

import {LegendConfiguration, LegendStyleType} from "../../../config/legend-configuration";
import {LegendItemList} from "./legend-item-list/legend-item-list";
import {TopicConfiguration} from "../../../config/topic-configuration";


interface LegendProps {
    uiStore: UiState;
    appStore: AppState;
    config: LegendConfiguration;
}

@observer
export class Legend extends React.Component<LegendProps, any> {
    widgetKey = "legend";
    constructor(props: LegendProps) {
        super(props);
        this.state = {
            visible: true
        };
    }

    render(): JSX.Element | null {
        if (!this.state.visible) {
            return null;
        }

        const topic = this.props.appStore.subtopic as TopicConfiguration;
        let content;
        if (!topic) {
            content = <span className={"info"}>Fachbereich auswählen...</span>;
        }

        if (!this.props.config.style || this.props.config.style.type === LegendStyleType.List) {
            content = (
                <LegendItemList
                    topic={topic}
                    layerInfos={this.props.config.layerInfos} />);
        }
        // TODO: Implement legend in card layout

        return (
            <div>
                <div className="geo-legend">
                    <div className="geo-legend-body">
                        {content}
                    </div>
                </div>
                <div className="geo-legend-footer"/>
            </div>
        );

    }
    componentDidMount(): void {
        const {uiStore} = this.props;
        if (!uiStore.widgets.has(this.widgetKey)) {
            uiStore.addWidget(this.widgetKey, this);
        }
    }
    componentWillUnmount(): void {
        const {uiStore} = this.props;
        uiStore.removeWidget(this.widgetKey);
    }
}
